const initialState = {
    shortDescription: null,
    longDescription: null,
    categoryId: null,
    images: null,
    openingBid: null,
    reservePrice: null,
    fixedPrice: null,
    durationDays: null,
    customEndTime: null,
    shippingOptions: null,
    itemCondition: null,
    memberConsent: null,
    step1: true,
    step2: true,
    step3: true,
    step4: true,
};

export default (state = initialState, action) => {
    const step1Errors = function (state) {
        return (
            !!state.shortDescription ||
            !!state.categoryId ||
            !!state.images ||
            !!state.longDescription ||
            !!state.itemCondition
        );
    };

    const step2Errors = function (state) {
        return (
            !!state.openingBid ||
            !!state.reservePrice ||
            !!state.fixedPrice ||
            !!state.durationDays ||
            !!state.customEndTime
        );
    };

    const step3Errors = function (state) {
        return !!state.shippingOptions;
    };

    const step4Errors = function (state) {
        return !!state.memberConsent;
    };

    switch (action.type) {
        case 'SET_ERROR':
            // eslint-disable-next-line better-mutation/no-mutation
            state = { ...state };
            // eslint-disable-next-line better-mutation/no-mutation
            state[action.propertyName] = action.error;
            break;
        default:
            return state;
    }

    const e1 = step1Errors(state);
    const e2 = step2Errors(state);
    const e3 = step3Errors(state);
    const e4 = step4Errors(state);
    // eslint-disable-next-line better-mutation/no-mutation
    state = {
        ...state,
        step1: e1 || undefined,
        step2: e2 || undefined,
        step3: e3 || undefined,
        step4: e4 || undefined,
    };

    return state;
};
